
import SideMenu from "@/components/WorkBench/SideMenu.vue"; //导入组件SideMenu:1
import { Options, Vue } from "vue-class-component"; //基本需要\
import { ElMessage } from "element-plus";
import {
  dispatchRecentTaskrecord,
  dispatchGetSkinReportOption,
  dispatchGetSkinReportWhole,
  dispatchGetSkinReportdata,
  dispatchGetSkinReportComparedata,
  dispatchGetSkinReportOptionOld,
  dispatchGetSkinReportList,
} from "@/store/performance/actions";
import fileSaver from "file-saver";
import * as XLSX from "xlsx";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  readDateVersions,
  readNewReportList,
  readNewReport,
  readSkinReport,
  readTaskRecordQuery,
  readTaskRecordDevices,
  readRecentTaskrecord,
  readSkinReportOption,
  readSkinReportWhole,
  readSkinReportData,
  readSkinReportcomparedata,
  readSkinReportOptionOld,
  readPerformanceVersion,
  readSkinReportList,
} from "@/store/performance/getters"; //引入仓库接口
import { store } from "@/store"; //引入仓库
import {
  readHeroSkin,
  readMobaProjects,
  readUserProfile,
} from "@/store/main/getters";
import {
  dispatchGetHeroSkin,
  dispatchGetMobaProjects,
  dispatchUpdateMyLastProject,
} from "@/store/main/actions";
import {
  dispatchGetProjectDetail,
  dispatchGetProjectScenes,
} from "@/store/project/actions";
import {
  readMyProjects,
  readProjectDetail,
  readAdminProjects,
} from "@/store/project/getters";
// 导入组件SideMenu:2
@Options({
  components: {
    SideMenu,
  },
})
export default class TestReportSkin extends Vue {
  public localProject = Number(getLocalProject()); //得到本地的项目
  public resBase64: any[] = [];
  //报告名称
  public contrast = true;
  public loading = false; //加载
  public formMail = {
    title: "", //标题
    Sender: "gamerobot@tencent.com", //发件人
    addressee: "", //收件人
    CC_List: "", //抄送人
  };
  public res(data) {
    console.log(data);
  }
  public option_key = 0;
  public spanArr = [];
  public cellMerge({ row, column, rowIndex, columnIndex }) {
    if (columnIndex === 0) {
      const _row = this.spanArr[rowIndex];
      const _col = _row > 0 ? 1 : 0;

      return {
        rowspan: _row,
        colspan: _col,
      };
    }
  }
  public handleSelectAll2(type) {
    if (type === "open") {
      let keys = Object.keys(this.skinReportOption.index_list);
      this.indicators = keys;
    } else {
      this.indicators = [];
    }
  }
  setFixedHeader() {
    const table: any = this.$refs.table;
    const header = table.$el.querySelector(".el-table__header-wrapper");
    const tableContainer = table.$el.querySelector(".el-table__body-wrapper");
    // console.log(header);
    const handleScroll = () => {
      const tableTop = table.$el.getBoundingClientRect().top;
      const tableBottom = table.$el.getBoundingClientRect().bottom;

      if (tableTop < 0 && tableBottom > header.offsetHeight) {
        header.style.position = "fixed";
        header.style.top = "0";
        header.style.zIndex = "100";
        header.style.width = `${tableContainer.clientWidth}px`;
        header.style.overflowX = "auto";
      } else {
        header.style.position = "";
        header.style.top = "";
        header.style.zIndex = "";
        header.style.width = "";
        header.style.overflowX = "";
      }
    };

    const syncScroll = (e) => {
      const target = e.target;
      if (target === header) {
        tableContainer.scrollLeft = target.scrollLeft;
      } else if (target === tableContainer) {
        header.scrollLeft = target.scrollLeft;
      }
    };
    window.addEventListener("scroll", handleScroll);
    header.addEventListener("scroll", syncScroll);
    tableContainer.addEventListener("scroll", syncScroll);

    (this as any).$once("hook:beforeDestroy", () => {
      window.removeEventListener("scroll", handleScroll);
      header.removeEventListener("scroll", syncScroll);
      tableContainer.removeEventListener("scroll", syncScroll);
    });
  }

  public difference(data, title, item, old) {
    let num: any = 0;
    if (JSON.stringify(this.SkinReportDataOld) !== "{}") {
      if (this.SkinReportDataOld[title]) {
        if (this.SkinReportDataOld[title][data["皮肤ID"]]) {
          num = this.SkinReportDataOld[title][data["皮肤ID"]][item];

          return "(" + (old - num).toFixed(2) + ")";
        } else {
          return "";
        }
      } else {
        return "";
      }
    } else {
      return "";
    }
  }
  public unique(array) {
    for (let i = 0; i < array.length; i++) {
      for (let j = i + 1; j < array.length; j++) {
        if (array[i] === array[j]) {
          array.splice(j, 1);
          j--;
        }
      }
    }
    return array;
  }

  public skin_id = "";
  public get skin_id_list() {
    return readSkinReportList(store).skin_list;
  }
  public async confirm() {
    this.$router.push({
      query: {
        ...this.$route.query,
        task_record: this.task_record_id.join(","),
        game_version: this.game_version,
        device_id: this.device,
      },
    });
    await dispatchGetSkinReportWhole(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      game_version: this.game_version,
    });
    this.fitstTable_new.forEach((v) => {
      this.spanArr = [];
      this.getSpanArr(v.data);
    });
    await dispatchGetSkinReportdata(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      device_id: Number(this.device) ? Number(this.device) : "",
      date: this.skinReportOption.game_versions.filter(
        (v) => v.game_version === this.game_version
      )[0]?.date,
      version: this.game_version,
      skin_id: this.skin_id,
    });
    this.SkinReportData_list();

    //  let keys= Object.values(this.SkinReportData)[0][0]
    //   console.log(Object.keys(keys))

    // this.leftList = this.thead.filter((header) =>
    //   this.indicators.includes(header.value)
    // );
    // this.rightList= this.thead1.filter(header => this.indicators.includes(header.value))
    // this.rightList = this.filterList(this.thead1, this.indicators);

    this.filter_list = this.indicators;
    // console.log(this.filter_list);

    await dispatchGetSkinReportComparedata(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      device_id: Number(this.device) ? Number(this.device) : "",
      date: this.skinReportOption.game_versions.filter(
        (v) => v.game_version === this.game_version_old
      )[0]?.date,
      version: this.game_version_old,
    });

    this.setFixedHeader();
  }
  public pos = 0;
  public getSpanArr(data) {
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        this.spanArr.push(1);
        this.pos = 0;
      } else {
        // 判断当前元素与上一个元素是否相同
        if (data[i].name === data[i - 1].name) {
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    }
  }
  public filter_list = [];
  public SkinReportData = {};
  public SkinReportData_list() {
    this.SkinReportData = JSON.parse(JSON.stringify(readSkinReportData(store)));
  }
  public get SkinReportDataOld() {
    return readSkinReportcomparedata(store);
  }
  public game_version: any = "";
  public game_version_old = "";
  public indicators = [];
  public device: any = "";
  public leftList = [];
  public rightList = [];
  public get the() {
    let list = [
      { name: "皮肤ID", value: "皮肤ID" },
      { name: "英雄名", value: "英雄名" },
      { name: "皮肤名", value: "皮肤名" },
      { name: "状态", value: "action" },
    ];
    return list;
  }
  public get thead() {
    let list = [];

    list = [
      { name: "Avg(FPS)", value: "Avg(FPS)" },
      { name: "Min(FPS)", value: "Min(FPS)" },
      { name: "Var(FPS)", value: "Var(FPS)" },
      { name: "Avg(AppCPU)[%])", value: "Avg(AppCPU)[%]" },
      { name: "Avg(AppGPU)[%]", value: "Avg(AppGPU)[%]" },
      { name: "Peak(Memory)[MB]", value: "peak_memory" },
      { name: "Peak(Memory+Swap)[MB]", value: "peak_memory_swap" },

      // {name:'MonoUpdateDt',value:[{name:'Avg',value:'Avg(MonoUpdateDt)'},{name:'Max',value:"Max(MonoUpdateDt)"}]},
      // {name:'MonoLateUpdateDt',value:[{name:'Avg',value:"Avg(MonoLateUpdateDt)"},{name:'Max',value:"Max(MonoLateUpdateDt)"}]},

      // {name:'PlayerRenderDt',value:[{name:'Avg',value:"Avg(PlayerRenderDt)"},{name:'Max',value:"Max(PlayerRenderDt)"}]},
      //  {name:'WaitForPresentDt',value:[{name:'Avg',value:"Avg(WaitForPresentDt)"},{name:'Max',value:"Max(WaitForPresentDt)"}]},
      //  {name:"DirectorUpdateAnimationDt",value:[{name:'Avg',value:"Avg(DirectorUpdateAnimationDt)"},{name:'Max',value:"Max(DirectorUpdateAnimationDt)"}]},
      //  {name:"AnimationDt",value:[{name:'Avg',value:"Avg(AnimationDt)"},{name:'Max',value:"Max(AnimationDt)"}]},
      //  {name:"AnimationDt",value:[{name:'Avg',value:"Avg(AnimationDt)"},{name:'Max',value:"Max(AnimationDt)"}]},
      //  {name:"AnimationDt",value:[{name:'Avg',value:"Avg(AnimationDt)"},{name:'Max',value:"Max(AnimationDt)"}]},
      //  {name:"MeshSkinningDt",value:[{name:'Avg',value:"Avg(MeshSkinningDt)"},{name:'Max',value:"Max(MeshSkinningDt)"}]},
      //  {name:"ParticleDt",value:[{name:'Avg',value:"Avg(ParticleDt)"},{name:'Max',value:"Max(ParticleDt)"}]},
      //  {name:"WillRenderCanvasesDt",value:[{name:'Avg',value:"Avg(WillRenderCanvasesDt)"},{name:'Max',value:"Max(WillRenderCanvasesDt)"}]},
      //  {name:"UpdateCanvasRectTransformDt",value:[{name:'Avg',value:"Avg(UpdateCanvasRectTransformDt)"},{name:'Max',value:"Max(UpdateCanvasRectTransformDt)"}]},
    ];
    return list;
  }
  filterList(list, queries) {
    return list
      .map((obj) => ({
        name: obj.name,
        value: obj.value.filter((item) => queries.includes(item.value)),
      }))
      .filter((obj) => obj.value.length > 0);
  }

  public get thead1() {
    let list = [];
    list = [
      {
        name: "MonoUpdateDt",
        value: [
          { name: "Avg", value: "Avg(MonoUpdateDt)" },
          { name: "Max", value: "Max(MonoUpdateDt)" },
        ],
      },
      {
        name: "MonoLateUpdateDt",
        value: [
          { name: "Avg", value: "Avg(MonoLateUpdateDt)" },
          { name: "Max", value: "Max(MonoLateUpdateDt)" },
        ],
      },

      {
        name: "PlayerRenderDt",
        value: [
          { name: "Avg", value: "Avg(PlayerRenderDt)" },
          { name: "Max", value: "Max(PlayerRenderDt)" },
        ],
      },
      {
        name: "WaitForPresentDt",
        value: [
          { name: "Avg", value: "Avg(WaitForPresentDt)" },
          { name: "Max", value: "Max(WaitForPresentDt)" },
        ],
      },
      {
        name: "DirectorUpdateAnimationDt",
        value: [
          { name: "Avg", value: "Avg(DirectorUpdateAnimationDt)" },
          { name: "Max", value: "Max(DirectorUpdateAnimationDt)" },
        ],
      },
      {
        name: "AnimationDt",
        value: [
          { name: "Avg", value: "Avg(AnimationDt)" },
          { name: "Max", value: "Max(AnimationDt)" },
        ],
      },
      {
        name: "AnimationDt",
        value: [
          { name: "Avg", value: "Avg(AnimationDt)" },
          { name: "Max", value: "Max(AnimationDt)" },
        ],
      },
      {
        name: "AnimationDt",
        value: [
          { name: "Avg", value: "Avg(AnimationDt)" },
          { name: "Max", value: "Max(AnimationDt)" },
        ],
      },
      {
        name: "MeshSkinningDt",
        value: [
          { name: "Avg", value: "Avg(MeshSkinningDt)" },
          { name: "Max", value: "Max(MeshSkinningDt)" },
        ],
      },
      {
        name: "ParticleDt",
        value: [
          { name: "Avg", value: "Avg(ParticleDt)" },
          { name: "Max", value: "Max(ParticleDt)" },
        ],
      },
      {
        name: "WillRenderCanvasesDt",
        value: [
          { name: "Avg", value: "Avg(WillRenderCanvasesDt)" },
          { name: "Max", value: "Max(WillRenderCanvasesDt)" },
        ],
      },
      {
        name: "UpdateCanvasRectTransformDt",
        value: [
          { name: "Avg", value: "Avg(UpdateCanvasRectTransformDt)" },
          { name: "Max", value: "Max(UpdateCanvasRectTransformDt)" },
        ],
      },
    ];
    return list;
  }
  public get skinReportOption() {
    return readSkinReportOption(store);
  }
  public get skinReportOption_old() {
    return readSkinReportOptionOld(store);
  }
  public skinChange() {
    this.game_version = "";
    this.device = "";
    dispatchGetSkinReportOption(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      skin_id: this.skin_id,
    });
  }
  public async taskChange() {
    // console.log(this.task_record_id);
    this.game_version = "";
    this.device = "";
    await dispatchGetSkinReportList(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
    });
    this.skin_id = "";
    await dispatchGetSkinReportOption(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      skin_id: this.skin_id,
    });
    this.option_key++;
    //  await dispatchGetSkinReportWhole(store,{
    //     project:this.localProject,
    //     task_record_id:(this.task_record_id as any).join('、')
    //   })

    let keys = Object.keys(this.skinReportOption.index_list);
    this.indicators = ["Avg(FPS)"];
  }
  public get RecentTaskrecord() {
    return readRecentTaskrecord(store);
  }
  public get firstTable() {
    return readSkinReportWhole(store);
  }
  public get fitstTable_new() {
    let list = [];
    for (let i in this.firstTable) {
      list.push({ title: i, data: [] });
    }
    for (let i in this.firstTable) {
      for (let item in this.firstTable[i]) {
        for (let k in this.firstTable[i][item]) {
          list
            .filter((v, index) => v.title == i)[0]
            .data.push({
              name: item,
              device: k,
              fps: this.firstTable[i][item][k][
                i == "Come" || i == "入场" ? "minfps标准" : "avgfps标准"
              ],
              testNum: this.firstTable[i][item][k]["测试皮肤数"],
              passNum: this.firstTable[i][item][k]["合格皮肤数"],
              rate:
                this.firstTable[i][item][k]["合格皮肤数"] /
                this.firstTable[i][item][k]["测试皮肤数"],
            });
        }
      }
    }
    return list;
  }
  //详情的路径
  public get_url(url: string) {
    let new_url = url;
    if (url) {
      let url_arr = url.split("/");
      if (url_arr[2] !== "runmax.oa.com") {
        let current_herf = window.parent.location.href;
        let f = current_herf.split("/");
        let domain = f[2];
        url_arr[2] = domain;
        new_url = url_arr.join("/");
        return new_url;
      }
    }
    return url;
  }
  public task_record_id: any = [];
  public table_exportExcel(item) {
    if (item.indexOf("report") != -1) {
      let name = Object.keys(this.SkinReportData);
      return name[item.split("-")[1]];
    } else {
      return item;
    }
  }
  public async exportExcel() {
    let list = [];
    this.fitstTable_new.forEach((v) => {
      list.push(v.title);
    });

    const keys = Object.keys(this.SkinReportData);
    for (let i = 0; i < keys.length; i++) {
      list.push("report-" + String(i));
    }

    for (const v of list) {
      await this.$nextTick();

      // 将导出操作封装为一个Promise
      const exportPromise = new Promise((resolve: any) => {
        var xlsxParam = { raw: true };
        var wb = XLSX.utils.table_to_book(
          document.querySelector(`#${v}`),
          xlsxParam
        );
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });

        try {
          fileSaver?.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            `${this.table_exportExcel(v)}.xlsx`
          );
          resolve();
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
          resolve();
        }
      });

      // 等待当前导出操作完成，并等待额外的500毫秒
      await exportPromise;
      await new Promise((resolve) => setTimeout(resolve, 500));
    }
  }
  public edit = false;
  public;
  public async mounted() {
    const project = Number(this.$route.query.project);
    // this.formMail.title = (readNewReportList(store) as any[]).filter(
    //   (item: any) => item.id === this.report_id
    // )[0].report_name;
    await dispatchRecentTaskrecord(store, {
      project: project,
      report_type: 3,
    }); //表格对应label
    // console.log(this.$route.query.task_record);
    if (this.$route.query.task_record === undefined) {
      this.task_record_id.push(this.RecentTaskrecord[0].value);
    } else {
      if (this.$route.query.task_record) {
        this.task_record_id = (this.$route.query.task_record as any)
          .split(",")
          .map(Number);
      } else {
        this.task_record_id = [];
      }
    }

    // console.log(this.task_record_id);

    await dispatchGetSkinReportOption(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      skin_id: this.skin_id,
    });
    await dispatchGetSkinReportList(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
    });

    await dispatchGetSkinReportOptionOld(store, {
      project: this.localProject,
    });

    if (this.$route.query.game_version === undefined) {
      this.game_version = this.skinReportOption.game_versions[0].game_version;
    } else {
      if (this.$route.query.game_version) {
        this.game_version = this.$route.query.game_version;
      } else {
        this.game_version = "";
      }
    }
    if (this.$route.query.device_id === undefined) {
      this.device = this.skinReportOption.device_list[0].device_id;
    } else {
      if (this.$route.query.device_id) {
        this.device = Number(this.$route.query.device_id);
      } else {
        this.device = "";
      }
    }

    this.$router.push({
      query: {
        ...this.$route.query,
        task_record: this.task_record_id.join(","),
        game_version: this.game_version,
        device_id: this.device,
      },
    });
    let keys = Object.keys(this.skinReportOption.index_list);
    this.indicators = ["Avg(FPS)"];
    this.filter_list = ["Avg(FPS)"];
    // this.leftList = this.thead.filter((header) =>
    //   this.indicators.includes(header.value)
    // );
    // this.rightList= this.thead1.filter(header => this.indicators.includes(header.value))
    // this.rightList = this.filterList(this.thead1, this.indicators);
    await dispatchGetSkinReportWhole(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      game_version: this.game_version,
    });
    this.fitstTable_new.forEach((v) => {
      this.spanArr = [];
      this.getSpanArr(v.data);
    });
    await dispatchGetSkinReportdata(store, {
      project: this.localProject,
      task_record_id: (this.task_record_id as any).join("、"),
      device_id: Number(this.device) ? Number(this.device) : "",
      date: this.skinReportOption.game_versions.filter(
        (v) => v.game_version === this.game_version
      )[0]?.date,
      version: this.game_version,
      skin_id: this.skin_id,
    });
    this.setFixedHeader();
  }
}
